import $ from "jquery";

$(document).on('click', '.homepage__cart-button', function(event) {
	event.preventDefault();
	$([document.documentElement, document.body]).animate({
		scrollTop: $('.checkout').offset().top,
	}, 500, 'swing');
});

if (_config.scrollToCart) {
	$([document.documentElement, document.body]).animate({
		scrollTop: $('.checkout').offset().top,
	}, 500, 'swing', function() {
		_config.scrolledToCart = true;
	});
}
